<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{ 'Advanced Search' | translate }}</h1>
      </div>
</div>
<div class="w3l-form-25">
  <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;" (click)="switchArabic()">ع </button>
  <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;" (click)="switchEnglish()">En</button>
</div>


</section>
<section class="w3l-hero-headers-11 p-sticky-md">
      <div class="top-header" >
              <div class="accounts" >
                  <ul>
                      <li style="align-items: center;"> </li>
                      <li></li>
                  </ul>
              </div>
              <div class="search" style="align-content: center;">
                  <form action="search-results.html" method="get" style="align-content: center;margin-left:25px;">
                      <input id="search1" name="search1" type="text" [(ngModel)]="patientCode" (keyup)="retrivePatients()" placeholder="Patient Code" style="width: 9%;">
                      <input id="search2" name="search2" type="text" [(ngModel)]="patientFName" (keyup)="retrivePatients()" placeholder="Patient Name" style="width: 19%;">
                      <select id="CancerType" name="CancerType"  class="styled-input" style="width: 8%;height: 40px;border-color: rgba(23, 8, 39, 0.096);" required="" [(ngModel)]= "cancerID" [value]="cancerID" (change)="retrivePatients()" >

                        <option value="{{Canc.cancerID}}" *ngFor="let Canc of cancerlist; let i = index">{{Canc.cancerName}}</option>
                      </select>
                      <input id="search3" name="search3" type="text" [(ngModel)]="telMobile" (keyup)="retrivePatients()" placeholder="Mobile No." style="width: 10%;">
                      <input id="search4" name="search4" type="text" [(ngModel)]="telHome"   (keyup)="retrivePatients()" placeholder="Home Telepone." style="width: 15%;">
                      <input id="telBusin" name="telBusin" type="text" [(ngModel)]="telBusin"  (keyup)="retrivePatients()" placeholder="Telepone 2" style="width: 10%;">
                      <input id="search5" name="search5" type="date" [(ngModel)]="birthDate"   style="width: 10%;">
                      <button mat-raised-button  class="theme-button btn fa fa-pencil-square-o"  style="width:6%;color: #fcfcfc; height: 35px; font-size: 85%;font-weight: bolder;margin-right: 160px;" (click)="retrivePatients_Birth()" >{{'Birth Date' | translate}}</button>

                    </form>
              </div>

      </div>
  </section>

  <table>
      <thead>
          <tr>
              <th style="width: 10%;">{{ 'Patient ID' | translate }}</th>
              <th style="width: 21%;">{{ 'Patient Name' | translate }}</th>
              <th style="width: 9%;">{{ 'Cancer Type' | translate }}</th>
              <th style="width: 10%;">{{ 'Mobile No.' | translate }}</th>
              <th style="width: 18%;">{{ 'Home Telephone' | translate }}</th>
              <th style="width: 10%;">{{ 'Telephone 2' | translate }}</th>
              <th style="width: 15%;">{{ 'Date of Birth' | translate }}</th>
              <th style="width: 5%;">{{ 'Select' | translate }}</th>

          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let pa of patientList; let i = index">
              <td data-column="Patient ID" >{{pa.patientCode}}</td>
              <td data-column="Patient Name" >{{pa.patientFName}}</td>
              <td data-column="Cancer Type">{{pa.cancerID}}</td>
              <td data-column="Mobile No." >{{pa.telMobile}}</td>
              <td data-column="Telephone No.1">{{pa.telHome}}</td>
              <td data-column="birthDate No.3">{{pa.telBusin}}</td>
              <td data-column="birthDate No.2">{{pa.birthDate}}</td>
              <td class="grid-td-th" data-column="Item Allocation">
                <a href="Dbank" class="drop-text">
                <button mat-raised-button  name="select" id="select" class="fa fa-pencil-square-o"  style="width:15px;background-color:#143d7b88;color: #fcfcfc; height: 30px; font-size: 85%;font-weight: bolder;" (click)="OpenDialogCall(pa)" >{{'Select' | translate}}</button>
                </a>
              </td>
            </tr>
      </tbody>
  </table>

